module.exports = __webpack_public_path__ + "img/box2_logo_dark.6713cb23.png";